// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__2j--z","dragIcon":"Choice_dragIcon__2Eo4W","left":"Choice_left__1fdo0","input":"Choice_input__1pAVO"};